import EmptyLayout from '@/views/layouts/empty-layout.vue'
import { CustomRouteRecordRaw } from 'vue-router'

export const workbenchRoutes: CustomRouteRecordRaw = {
  path: 'workbench',
  name: 'workbench',
  redirect: { name: 'workbenchIndex' },
  component: EmptyLayout,
  meta: {
    title: '工作台',
    noQuick: true,
    iconfont: 'icon-currency_exchange_black_24dp',

  },
  children: [
    // 项目列表
    {
      path: 'workbenchIndex',
      name: 'workbenchIndex',
      component: () => import('@/views/workbench/workbench.vue'),
      meta: {
        iconfont: 'icon-currency_exchange_black_24dp',
        title: '工作台',
        noQuick: true,

      },
    },
  ],
}
